import React, { Component } from 'react';
import { gql } from '@apollo/client';
import { Mutation } from '@apollo/react-components';
import { Button, Popconfirm } from 'antd';
import moment from 'moment';
import styles from './styles.scss';

const DELETE_MEMORY_ESTIMATE = gql`
  mutation DeleteMemoryEstimate($input: DeleteMemoryEstimateInput!) {
    deleteMemoryEstimate(input: $input) {
      memoryEstimate {
        uuid
      }
    }
  }
`;

class DeleteMemoryEstimate extends Component {
  render() {
    const { memoryEstimate } = this.props;
    const { uuid, userUuid, itemUuid, strength, createdAt, updatedAt } = memoryEstimate;
    const formattedCreated = moment(createdAt).toISOString();
    const formattedUpdated = moment(updatedAt).toISOString();

    return (
      <Mutation mutation={DELETE_MEMORY_ESTIMATE}>
        {(deleteMemoryEstimate, { loading, data }) => {
          return (
            <div className={styles.layout}>
              <div>
                User: {userUuid} | Item: {itemUuid} | {strength} | {formattedCreated} |{' '}
                {formattedUpdated}
              </div>
              <Popconfirm
                title="Are you sure?"
                onConfirm={() => deleteMemoryEstimate({ variables: { input: { uuid } } })}
              >
                <Button size="small" loading={loading} disabled={data}>
                  {data ? 'deleted' : 'delete'}
                </Button>
              </Popconfirm>
            </div>
          );
        }}
      </Mutation>
    );
  }
}

export default DeleteMemoryEstimate;
